import { PointCurrency } from 'constants/enums';

export const STARS_VALUE: { [key: string]: number } = {
  [PointCurrency.STAR]: 1,
  [PointCurrency.STAR2]: 2,
  [PointCurrency.STAR3]: 3,
};
